import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

export const coverageFeedSourceList = (params = '') => Http.get(`/coverage-feed-sources${serialize(params)}`)
export const coverageFeedSourceCreate = (params = '') => Http.post('/coverage-feed-sources', params)
export const coverageFeedSourceUpdate = (params = '') => Http.put(`/coverage-feed-sources/${params.id}`, params)
export const coverageFeedSourceDestroy = (params = '') => Http.delete(`/coverage-feed-sources/${params.id}`)
export const coverageFeedSourceTest = (params = '') => Http.post(`/coverage-feed-sources/${params.id}/test`)
export const coverageFeedSourceSyncDirectory = () => Http.post('/coverage-feed-sources/sync-directory')
